/* React */

import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';

/* Material-UI */

import {
  Button, Container, darken, Grid, Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TranslateIcon from '@material-ui/icons/Translate';

/* Local Imports */
import LanguageDialog from '@/components/ui-components/LanguageSwitcher';

/* Style */
const useStyles = makeStyles((theme) => ({
  footer: {
    marginBottom: theme.spacing(2),

  },
  languageBtn: {
    color: darken(theme.palette.primary.main, 0.2),
  },
}));

const Footer:React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation('common');
  const [languageSwitcherOpen, setLanguageSwitcherOpen] = useState(false);

  return (
    <>
      <Container>
        <Grid
          container
          spacing={1}
          direction="row"
          justify="center"
          alignItems="center"
          alignContent="center"
          className={classes.footer}
        >
          <Button
            className={classes.languageBtn}
            startIcon={<TranslateIcon />}
            onClick={() => setLanguageSwitcherOpen(true)}
          >
            <Typography
              variant="body1"
            >
              {t('currentLanguage')}
            </Typography>
          </Button>
        </Grid>

      </Container>
      <LanguageDialog
        onClose={() => setLanguageSwitcherOpen(false)}
        open={languageSwitcherOpen}
      />
    </>
  );
};
export default Footer;
